// extracted by mini-css-extract-plugin
module.exports = {"compact":"RemoveButton_compact__3HMM6"};